/**
 * Custom error that should not be reported to Sentry.
 * Throw this (or a subclass) when the error is expected/handled and would only add noise.
 *
 * Accepts the same parameters as the native Error constructor.
 *
 * @example
 * throw new SentryIgnoredError('Failed to send via Peppol');
 * throw new SentryIgnoredError('Failed', { cause: originalError });
 */
export class SentryIgnoredError extends Error {
  constructor(message?: string, options?: ErrorOptions) {
    super(message, options);
    this.name = 'SentryIgnoredError';
    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, SentryIgnoredError);
    }
    // Subclassing built-ins in ES5-style bundles (e.g. transpiled TS) requires this
    Object.setPrototypeOf(this, SentryIgnoredError.prototype);
  }
}
